<template>
  <div :class="containerClass" @click="onWrapperClick">
    <template v-if="$auth.isLoggedIn">
      <div class="layout-topbar bg-blue-900 shadow-6">
        <div>
          <button
            class="p-link layout-topbar-button text-white layout-topbar-menu-button my-2 mr-2"
            @click="onMenuToggle"
          >
            <i class="pi pi-bars"></i>
          </button>
        </div>
        <router-link to="/" class="layout-topbar-logo flex-grow-none">
          <span class="text-white text-sm">GWCL HELP CENTER</span>
        </router-link>
        <div>
          <audio id="remoteAudio" autoplay hidden></audio>
        </div>
        <div class="layout-topbar-menu flex-grow-1 justify-content-between">
          <div class="flex">
            <template v-for="(item, i) of navbarTopLeftItems" :key="i">
              <router-link :to="item.to">
                <Button
                  :label="item.label"
                  :icon="item.icon"
                  class="p-button-text text-white page-button"
                />
              </router-link>
            </template>
          </div>
          <div class="hidden-xs">
            <Button
              icon="pi pi-arrow-left"
              class="p-button-sm p-button-rounded p-button-outlined text-white px-4 mx-2"
              @click="
                () => {
                  $router.go(-1);
                }
              "
            />
            <Button
              icon="pi pi-arrow-right"
              class="p-button-sm p-button-rounded p-button-outlined text-white px-4 mx-2"
              @click="
                () => {
                  $router.go(+1);
                }
              "
            />
          </div>
          <SplitButton
            class="layout-menu-user-button"
            icon="pi pi-user"
            :model="appBarActionMenu"
          >
            <div class="text-white py-3"># {{ $auth.userName }}</div>
            <router-link to="/account">
              <Avatar
                shape="circle"
                class="bg-blue-900 text-white"
                size="large"
                icon="pi pi-user"
              />
            </router-link>
          </SplitButton>
        </div>
      </div>
      <div class="layout-sidebar" @click="onSidebarClick">
        <div v-if="pageDefaultValues.showCallTimer">
          <div class="flex justify-content-center px-3 py-2 bg-green-300">
            <div>
              <div class="text-sm font-bold my-1">
                {{ pageDefaultValues.txtCallStatus }} -
                {{ pageDefaultValues.callTimer }}
              </div>
            </div>
          </div>
          <div
            style="border-color: rgb(58 171 99)"
            class="flex justify-content-around border-top-1 border-bottom-1 px-0 pb-2 pt-2 bg-green-300"
          >
            <div>
              <Button
                :icon="
                  !pageDefaultValues.isCallMuted
                    ? 'pi pi-volume-up'
                    : 'pi pi-volume-off'
                "
                :label="!pageDefaultValues.isCallMuted ? 'Mute' : 'UnMute'"
                title="Mute"
                class="p-button-sm mx-1 px-2 callTimerBtn"
                :class="
                  pageDefaultValues.isCallMuted
                    ? 'p-button-secondary'
                    : 'p-button-info'
                "
                @click="muteCall"
              />
              <Button
                :icon="
                  pageDefaultValues.isCallOnHold ? 'pi pi-play' : 'pi pi-pause'
                "
                :label="pageDefaultValues.isCallOnHold ? 'UnHold' : 'Hold'"
                title="Hold"
                class="p-button-sm mx-1 px-2 callTimerBtn"
                :class="
                  pageDefaultValues.isCallOnHold
                    ? 'p-button-secondary'
                    : 'p-button-info'
                "
                @click="holdCall"
              />
              <Button
                icon="pi pi-times"
                label="End"
                title="End Call"
                class="p-button-sm p-button-danger mx-1 px-2 callTimerBtn"
                @click="terminateCall"
              />
            </div>
          </div>
          <div
            v-if="pageDefaultValues.currentIncomingCaller"
            class="px-2 py-2 mb-1"
          >
            <Button
              label="Create New Ticket"
              class="p-button-success w-full mt-2"
              @click="
                app.navigateTo(
                  `/complaints/add/${pageDefaultValues.currentIncomingCaller}/incoming`
                )
              "
            />
          </div>
          <div
            class="bg-green-300 pt-2"
            v-if="!pageDefaultValues.txtTransferStatus"
          >
            <form
              ref="observer"
              tag="form"
              @submit.prevent="transferCall()"
              class="px-2 pb-2 mt-2"
            >
              <div class="mb-1 px-2 font-bold text-lg">
                <small>Transfer Call:</small>
              </div>
              <div class="grid comp-grid">
                <div class="col-12 mb-0">
                  <api-data-source
                    api-path="components_data/call_center_users_telephone_option_list"
                  >
                    <template v-slot="req">
                      <Dropdown
                        class="w-full"
                        style="width: 100%"
                        :filter="true"
                        :loading="req.loading"
                        pattern="^[0-9]+$"
                        optionLabel="label"
                        optionValue="value"
                        v-model="pageDefaultValues.callTransaferInputField"
                        :options="req.response"
                        label="Select Agent.. "
                        placeholder="Select Agent.. "
                      >
                        <template #option="slotProps">
                          <div class="flex align-items-center">
                            <div>
                              <div>{{ slotProps.option.label }}</div>
                              <div
                                v-if="slotProps.option.caption"
                                class="text-sm text-500"
                              >
                                {{ slotProps.option.caption }}
                              </div>
                            </div>
                          </div>
                        </template>
                      </Dropdown>
                    </template>
                  </api-data-source>
                  <Button
                    type="submit"
                    :disabled="!pageDefaultValues.callTransaferInputField"
                    label="Transfer Call"
                    class="p-button-help w-full mt-2"
                    :loading="pageDefaultValues.tranferring"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="bg-green-300" v-if="pageDefaultValues.txtTransferStatus">
          <ul class="my-0 py-2">
            <li>{{ pageDefaultValues.txtTransferStatus }}</li>
          </ul>
        </div>

        <div v-if="pageDefaultValues.showRegDialog">
          <div
            class="flex justify-content-between"
            :class="pageDefaultValues.showRegDialogColor"
          >
            <div class="text-sm py-3 pl-3 font-bold">
              <i class="pi pi-phone mr-2"></i>
              <span class=""> {{ pageDefaultValues.txtRegStatus }}</span>
            </div>

            <div v-if="pageDefaultValues.isSipConnected" class="py-2 mt-1 mr-2">
              <Button
                label="Break"
                :loading="pageDefaultValues.saving"
                class="p-button-sm p-button-secondary mx-1 py-1"
                @click="sipUnRegister(true)"
              />
            </div>
            <div v-else class="py-2 mt-1 mr-2">
              <Button
                :label="
                  pageDefaultValues.breakInterval != 60
                    ? 'Connect (' + pageDefaultValues.breakInterval + ')'
                    : 'Connect'
                "
                :loading="pageDefaultValues.saving"
                class="p-button-sm p-button-success mx-1 py-1"
                @click="preInitJsSip"
              />
            </div>
          </div>
        </div>

        <div
          v-if="!pageDefaultValues.showCallTimer"
          class="text-center bg-bluegray-100 mb-0 animate__animated animate__pulse animate__faster"
        >
          <div v-if="$auth.userPhoto">
            <router-link to="/account">
              <img
                style="max-width: 100%"
                :src="$utils.setImgUrl($auth.userPhoto, 'medium')"
              />
            </router-link>
          </div>
          <div class="pt-3 pb-5" v-else>
            <router-link to="/account">
              <img
                class=""
                src="images/logo.png"
                alt="logo"
                style="height: 90px"
              />
            </router-link>
          </div>
        </div>
        <AppMenu
          :model="navbarSideLeftItems"
          @menuitem-click="onMenuItemClick"
        />
      </div>
    </template>
    <template v-else>
      <div class="layout-topbar bg-blue-900 text-white shadow-6"></div>
    </template>
    <div class="layout-main-container">
      <div class="layout-main">
        <router-view />
      </div>
      <div
        v-if="$auth.isLoggedIn"
        class="layout-footer justify-content-between align-items-center card mt-3"
      >
        <div class="mr-2">
          <span class="hidden-xs text-sm text-500 ml-2 text-md"
            ><b>© {{ new Date().getFullYear() }} GWCL HELP CENTER .</b> Powered
            by
            <a href="https://www.afrifanom.com" target="_blank"
              >Afrifanom Limited</a
            >
          </span>
        </div>
      </div>
    </div>
    <!-- App right drawer -->
    <Sidebar
      :showCloseIcon="false"
      position="right"
      v-model:visible="showRightDrawer"
      :style="{ width: rightDrawer.width }"
    >
      <component
        v-if="showRightDrawer"
        is-sub-page
        :is="drawerComponentFile"
        :api-path="rightDrawer.pageUrl"
        :page-data="rightDrawer.pageData"
      />
    </Sidebar>
    <transition name="layout-mask">
      <div
        class="layout-mask p-component-overlay"
        v-if="mobileMenuActive"
      ></div>
    </transition>
    <!-- Page display dialog -->
    <Dialog
      class="card py-3 px-0"
      id="style-1"
      :breakpoints="{ '960px': '50vw', '640px': '95vw' }"
      :style="{ width: pageDialog.width, maxWidth: pageDialog.maxWidth }"
      :modal="!pageDialog.seamless"
      :maximized="pageDialog.maximized"
      :dismissableMask="!pageDialog.persistent"
      :position="pageDialog.position"
      v-model:visible="showPageDialog"
      :showHeader="false"
    >
      <Button
        v-if="pageDialog.closeBtn"
        @click="showPageDialog = false"
        style="position: absolute; right: 20px; top: 15px"
        icon="pi pi-times"
        class="p-button-rounded p-button-outlined p-button-danger"
      />
      <component
        v-if="pageDialog.showDialog"
        is-sub-page
        :is="dialogComponentFile"
        :api-path="pageDialog.pageUrl"
        :page-data="pageDialog.pageData"
      />
    </Dialog>
    <!-- image preview dialog-->
    <Dialog
      class="card p-0"
      header="..."
      :showHeader="true"
      :breakpoints="{ '960px': '40vw', '640px': '95vw' }"
      style="width: auto"
      v-model:visible="showImageDialog"
      dismissableMask
      modal
    >
      <div class="text-center">
        <Carousel
          v-if="imageDialog.images.length > 1"
          :value="imageDialog.images"
          :circular="false"
          :page="imageDialog.currentSlide"
        >
          <template #item="{ data }">
            <div class="text-center">
              <NiceImage
                style="max-width: 100%; max-height: 70vh"
                :src="data"
              />
            </div>
          </template>
        </Carousel>
        <NiceImage
          v-else
          style="max-width: 100%; max-height: 70vh"
          :src="imageDialog.images[0]"
        />
      </div>
    </Dialog>
    <!-- request error dialog -->
    <Dialog
      modal
      v-model:visible="errorDialog"
      :breakpoints="{ '960px': '50vw', '640px': '95vw' }"
      style="width: 30vw"
      position="bottom"
    >
      <template #header>
        <div class="flex align-items-center">
          <div class="mr-2">
            <Avatar
              size="large"
              class="bg-pink-50 text-pink-600"
              icon="pi pi-exclamation-triangle"
            />
          </div>
          <div class="flex text-md text-pink-600 font-bold">Ooops!</div>
        </div>
      </template>
      <div class="">
        <div
          class="text-grey-500 text-md"
          v-for="(msg, index) in pageErrors"
          :key="index"
        >
          <div class="card text-pink-600 mb-1 text-lg">- {{ msg }}</div>
        </div>
      </div>
    </Dialog>
    <ConfirmDialog></ConfirmDialog>
    <Toast position="top-right"> </Toast>
    <!-- fullscreen loader -->
    <Dialog
      class="card m-0 text-center"
      :showHeader="false"
      modal
      v-model:visible="fullScreenLoading"
      :breakpoints="{ '960px': '50vw', '640px': '95vw' }"
      style="width: 20vw"
      position="center"
    >
      <ProgressSpinner style="width: 60px" />
      <div>{{ fullScreenLoadingMsg }}</div>
    </Dialog>
    <!-- incoming call dialog -->
    <Dialog
      header="Incoming Call"
      v-model:visible="pageDefaultValues.showCallDialog"
      :breakpoints="{ '960px': '55vw', '640px': '70vw' }"
      :style="{ width: '20vw' }"
      :position="'topleft'"
      :closable="false"
      :modal="true"
      :dismissableMask="false"
    >
      <div class="px-1 m-0 text-lg">
        <i class="pi pi-phone mr-2"></i>
        <span class=""> {{ pageDefaultValues.txtCallStatus }}</span>
      </div>
      <Divider class="mt-3 mb-0" />
      <template #footer>
        <div class="grid px-1 py-0">
          <!-- <div>
            <Button
              icon="pi pi-undo"
              label="Not ready"
              class="p-button-rounded p-button-outlined p-button-primary mx-1"
              @click="terminateCall"
            />
          </div> -->
          <Button
            class="p-button-rounded p-button-success mx-1 w-full"
            label="Answer"
            autofocus
            :loading="pageDefaultValues.answering"
            @click="answerCall"
          />
        </div>
      </template>
    </Dialog>
    <!-- call back dialog -->
    <Dialog
      header="Outbound Call"
      v-model:visible="showCallBackDialog"
      dismissableMask
      :breakpoints="{ '960px': '55vw', '640px': '70vw' }"
      :style="{ width: '25vw' }"
      :position="'center'"
      modal
      :closable="false"
    >
      <Button
        @click="showCallBackDialog = false"
        style="position: absolute; right: 15px; top: 5px"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-plain"
      />
      <div class="px-1 m-0 text-lg">
        <span class=""> {{ callBackDialog.description }}</span>
      </div>
      <Divider class="mt-3 mb-0" />
      <template #footer>
        <div class="flex justify-content-end px-1 py-0">
          <div>
            <Button
              icon="pi pi-phone"
              class="p-button-rounded p-button-success mx-1"
              label="Yes, Call Now"
              autofocus
              :loading="pageDefaultValues.calling"
              @click="outgoingCall(callBackDialog.contact)"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>
<script setup>
import {
  defineAsyncComponent,
  reactive,
  ref,
  watch,
  computed,
  onMounted,
} from "vue";
import AppMenu from "@/components/AppMenu.vue";
import { useApp } from "@/composables/app";
import { useAuth } from "@/composables/auth";
import { useRoute, useRouter } from "vue-router";
import { ApiService } from "@/services/api";
import { useStore } from "vuex";
import { utils } from "@/utils";
import { StorageService } from "./services/storage";
import JsSIP from "jssip";
import https from "https";

const ringtone = require("./assets/sounds/ringtone.wav");
const ringbacktone = require("./assets/sounds/ringbacktone.wav");
const sipServer = {
  domain: "172.16.6.7",
  wss: "wss://172.16.6.7:2609/ws",
};
// const sipServer = {
//   domain: "192.168.2.109",
//   wss: "wss://192.168.2.109:8089/ws",
// };

const app = useApp();
const auth = useAuth();
const store = useStore();
const route = useRoute();
const router = useRouter();

const pageDialog = computed(() => store.state.app.pageDialog);
const imageDialog = computed(() => store.state.app.imageDialog);
const rightDrawer = computed(() => store.state.app.rightDrawer);
const callBackDialog = computed(() => store.state.app.callBackDialog);

let onTicketSubmitted = computed(() => store.state.app.onTicketSubmitted);
let onActiveCall = computed(() => store.state.app.onActiveCall);
let sipSessionTrackerCode = computed(
  () => store.state.app.sipSessionTrackerCode
);

var oUserAgent,
  oConfig,
  oSession,
  callTimerinterval,
  callOptions,
  remoteAudio,
  ringtoneAudio,
  dtmfSender,
  breakIntervalHandler;

const pageDefaults = {
  saving: false,
  tranferring: false,
  answering: false,
  calling: false,
  showCallDialog: false,
  showCallTimer: false,
  showRegDialog: auth.userDistrict == "Call Center" ? true : false,
  showRegDialogColor: "bg-yellow-400",
  isSipConnected: false,
  callTimer: "00:00",
  txtRegStatus: "",
  txtCallStatus: "",
  txtTransferStatus: "",
  callTransaferInputField: "",
  isCallMuted: false,
  isCallOnHold: false,
  currentIncomingCaller: "",
  breakInterval: 60,
};
const pageDefaultValues = reactive({ ...pageDefaults });

const showPageDialog = computed({
  get() {
    return pageDialog.value.showDialog;
  },
  set(value) {
    store.dispatch("app/closePageDialog");
  },
});

const showImageDialog = computed({
  get() {
    return imageDialog.value.showDialog;
  },
  set(value) {
    store.dispatch("app/closeImageDialog");
  },
});

const showCallBackDialog = computed({
  get() {
    return callBackDialog.value.showDialog;
  },
  set(value) {
    store.dispatch("app/closeCallBackDialog");
  },
});

const showRightDrawer = computed({
  get() {
    return rightDrawer.value.showDrawer;
  },
  set(value) {
    store.dispatch("app/closeRightDrawer");
  },
});

const pageErrors = computed({
  get() {
    return store.state.app.pageErrors;
  },
  set(value) {
    store.commit("app/setPageErrors", value);
  },
});

const errorDialog = computed({
  get() {
    return pageErrors.value.length > 0;
  },
  set(newValue) {
    pageErrors.value = [];
  },
});

const fullScreenLoading = computed(() => store.state.app.fullScreenLoading);
const fullScreenLoadingMsg = computed(
  () => store.state.app.fullScreenLoadingMsg
);

const dialogComponentFile = computed(() => {
  const dialog = pageDialog.value;
  if (dialog.showDialog && dialog.pageComponent) {
    return defineAsyncComponent(() =>
      import(`@/pages/${dialog.pageComponent}.vue`)
    );
  }
  return null;
});
const drawerComponentFile = computed(() => {
  const drawer = rightDrawer.value;
  if (drawer.showDrawer && drawer.pageComponent) {
    return defineAsyncComponent(() =>
      import(`@/pages/${drawer.pageComponent}.vue`)
    );
  }
  return null;
});
const layoutMode = ref("static");
const menuClick = ref(false);
const staticMenuInactive = ref(false);
const overlayMenuActive = ref(false);
const mobileMenuActive = ref(false);

const containerClass = computed(() => {
  if (!auth.isLoggedIn) {
    staticMenuInactive.value = true;
    mobileMenuActive.value = false;
  }

  return [
    "layout-wrapper",
    {
      "layout-overlay": layoutMode.value === "overlay",
      "layout-static": layoutMode.value === "static",
      "layout-static-sidebar-inactive":
        staticMenuInactive.value && layoutMode.value === "static",
      "layout-overlay-sidebar-active":
        overlayMenuActive.value && layoutMode.value === "overlay",
      "layout-mobile-sidebar-active": mobileMenuActive.value,
      "p-input-filled": false,
    },
  ];
});

const navbarSideLeftItems = app.menus.navbarSideLeftItems.filter((menu) =>
  auth.canView(menu.to)
);
const navbarTopLeftItems = app.menus.navbarTopLeftItems.filter((menu) =>
  auth.canView(menu.to)
);
const navbarTopRightItems = app.menus.navbarTopRightItems.filter((menu) =>
  auth.canView(menu.to)
);
function onMenuItemClick(event) {
  if (event.item && !event.item.items) {
    overlayMenuActive.value = false;
    mobileMenuActive.value = false;
  }
}

function onWrapperClick() {
  if (!menuClick.value) {
    overlayMenuActive.value = false;
    mobileMenuActive.value = false;
  }
  menuClick.value = false;
}

function onMenuToggle() {
  menuClick.value = true;
  if (app.isDesktop()) {
    if (layoutMode.value === "overlay") {
      if (mobileMenuActive.value === true) {
        overlayMenuActive.value = true;
      }
      overlayMenuActive.value = !overlayMenuActive.value;
      mobileMenuActive.value = false;
    } else if (layoutMode.value === "static") {
      staticMenuInactive.value = !staticMenuInactive.value;
    }
  } else {
    mobileMenuActive.value = !mobileMenuActive.value;
  }
}

function startAnsweredCall() {
  let totalSeconds = 0; // in minutes
  let minutes = 0;
  let seconds = 0;
  callTimerinterval = setInterval(function () {
    totalSeconds++;
    seconds = pad(totalSeconds % 60);
    minutes = pad(parseInt(totalSeconds / 60));
    let countUpTime = minutes + ":" + seconds;
    Object.assign(pageDefaultValues, { callTimer: countUpTime });
  }, 1000);
}

function pad(val) {
  var valString = val + "";
  if (valString.length < 2) {
    return "0" + valString;
  } else {
    return valString;
  }
}

const appBarActionMenu = [
  {
    to: "/account",
    label: "My Account",
    icon: "pi pi-user",
  },
  {
    label: "Logout",
    icon: "pi pi-window-minimize",
    command: (event) => {
      startLogout();
    },
  },
];

function startLogout() {
  // Unregister SIP
  sipUnRegister(false);

  auth.logout();
  location.href = "/"; //reload page and navigated to index page
}

function initAxioInterceptors() {
  // Add a request interceptor
  ApiService.axios().interceptors.request.use(
    (config) => {
      //before new request, hide previous error message
      pageErrors.value = [];
      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    }
  );
}

initAxioInterceptors();

onMounted(() => {
  remoteAudio = document.getElementById("remoteAudio");
  // Start JsSip and Register User
  if (auth.userDistrict == "Call Center") {
    preInitJsSip();
  }
});

function Timer() {
  Object.assign(pageDefaultValues, {
    breakInterval: pageDefaultValues.breakInterval - 1,
  });
  if (pageDefaultValues.breakInterval < 1) {
    clearInterval(breakIntervalHandler);
    store.commit("app/setOnTicketSubmitted", 0);
    Object.assign(pageDefaultValues, { breakInterval: 60 });
  }
}

watch(sipSessionTrackerCode, () => {
  if (oUserAgent) {
    if (onTicketSubmitted.value == 1 && !onActiveCall.value) {
      app.flashMsg(
        "Ticket not saved",
        "Last caller's complaint ticket is not saved",
        "warn",
        6000
      );
      oUserAgent.stop();
      breakIntervalHandler = setInterval(Timer, 1000);
      setTimeout(function () {
        sipRegister();
      }, 60000);
    }
  }
});

function preInitJsSip() {
  // Enable debugging - use JsSIP.debug.disable('JsSIP:*') to disable debugging
  JsSIP.debug.disable("JsSIP:*");

  var socket = new JsSIP.WebSocketInterface(sipServer.wss, {
    requestOptions: { agent: new https.Agent({ rejectUnauthorized: false }) },
    rejectUnauthorized: false,
    strictSSL: false,
  });

  let sipPass = Buffer.from(`!webrtc${auth.userTelephone}rtc`).toString(
    "base64"
  );

  oConfig = {
    sockets: [socket],
    uri: `sip:${auth.userTelephone}@${sipServer.domain}`,
    authorization_user: `${auth.userTelephone}`,
    password: `${sipPass}`,
    realm: sipServer.domain,
    no_answer_timeout: 60,
    display_name: `${auth.userFirstName} @ Help Center`,
    registrar_server: `sip:${sipServer.domain}`,
    connection_recovery_min_interval: 4,
    connection_recovery_max_interval: 60,
    register: true,
  };

  callOptions = {
    extraHeaders: ["CatchPhrase: XXXXXXXXX"],
    mediaConstraints: {
      audio: true, // only audio calls
      video: false,
    },
  };

  try {
    oUserAgent = new JsSIP.UA(oConfig);
  } catch (e) {
    console.log(e);
    return;
  }

  // Transport connection/disconnection callbacks
  oUserAgent.on("connecting", function () {
    Object.assign(pageDefaultValues, {
      showRegDialogColor: "bg-yellow-400",
      txtRegStatus: "Connecting...",
      saving: true,
      isSipConnected: false,
    });
    StorageService.saveSipConnState("connecting");
  });
  oUserAgent.on("connected", function () {
    Object.assign(pageDefaultValues, {
      showRegDialogColor: "bg-green-400",
      txtRegStatus: "Connected",
      isSipConnected: true,
      saving: false,
    });
    StorageService.saveSipConnState("connected");
  });
  oUserAgent.on("disconnected", function () {
    Object.assign(pageDefaultValues, {
      showRegDialogColor: "bg-yellow-400",
      txtRegStatus: "You are Offline",
      saving: false,
      isSipConnected: false,
    });
    if (onTicketSubmitted.value == 1 && !onActiveCall.value) {
      Object.assign(pageDefaultValues, {
        txtRegStatus: "Quick break",
        showRegDialogColor: "bg-pink-200",
      });
    }
    StorageService.saveSipConnState("disconnected");
  });
  oUserAgent.on("registrationFailed", function () {
    Object.assign(pageDefaultValues, {
      showRegDialogColor: "bg-pink-300",
      txtRegStatus: "Unable to connect",
      saving: false,
      isSipConnected: false,
    });
  });

  // Call/Message reception callbacks
  oUserAgent.on("newRTCSession", function (e) {
    var session = e.session;
    var request = e.request;
    var status = session?.direction;

    session.on("muted", function (e) {
      setCallSessionStatus(session, "muted", request);
    });
    session.on("unmuted", function (e) {
      setCallSessionStatus(session, "unmuted", request);
    });
    session.on("hold", function (e) {
      setCallSessionStatus(session, "hold", request);
    });
    session.on("unhold", function (e) {
      setCallSessionStatus(session, "unhold", request);
    });

    if (status === "incoming") {
      session.on("connecting", function (e) {
        setCallSessionStatus(session, "connecting", request);
      });
      // incoming call here
      session.on("accepted", function (e) {
        setCallSessionStatus(session, "accepted", request);
      });
      // when the call is confirmed
      session.on("confirmed", function (e) {});
      // the call has ended
      session.on("ended", function (e) {
        setCallSessionStatus(session, "terminated", request);
        let src = request?.from?._uri?._user;
      });
      // unable to establish the call
      session.on("failed", function (e) {
        setCallSessionStatus(session, "terminated", request);
      });
      // session.on("_failed", function (e) {
      //   if (!oSession) setCallSessionStatus(session, "terminated", request);
      // });
      session.on("peerconnection", function (e) {
        e.peerconnection.addEventListener("addstream", function (e) {
          // set remote audio stream
          remoteAudio.srcObject = e.stream;
          remoteAudio.play();
        });
      });
      session.on("progress", function (e) {
        if (!oSession) setCallSessionStatus(session, "incoming", request);
      });

      if (!oSession) setCallSessionStatus(session, "incoming", request);
    }

    if (status === "outgoing") {
      session.on("accepted", function (e) {});
      // the call has ended
      session.on("ended", function (e) {
        setCallSessionStatus(session, "terminated", request);
        var src = request?.from?._uri?._user; // From ext
        var dst = request?.to?._uri?._user; // To ext
        fetchCallPlaybackAudio(src, dst, "outgoing");
        if (oUserAgent.isConnected()) {
          sipUnRegister(true);
        }
      });
      // unable to establish the call
      session.on("failed", function (e) {
        setCallSessionStatus(session, "terminated", request);
        if (oUserAgent.isConnected()) {
          sipUnRegister(true);
        }
      });
      session.on("sending", function (e) {
        setCallSessionStatus(session, "outgoing", request);
      });
    }
  });

  // let connState = StorageService.getSipConnState();
  // console.log("_________________", connState)
  // if (connState == "connected") {}
 
  // Register SIP
  if (auth.isLoggedIn && !oUserAgent.isConnected()) sipRegister();
}

function sipRegister() {
  Object.assign(pageDefaultValues, { saving: true });
  if (!oUserAgent.isConnected()) {
    oUserAgent.start();
    Object.assign(pageDefaultValues, { breakInterval: 60 });
    clearInterval(breakIntervalHandler);
  }
}

function sipUnRegister(showLoadingBtn) {
  Object.assign(pageDefaultValues, { saving: showLoadingBtn });
  if (oUserAgent) {
    oUserAgent.stop();
    oUserAgent.unregister();
  }
}

var outgoingCall = function (contact) {
  if (!oSession) {
    Object.assign(pageDefaultValues, { calling: true });
    callOptions.eventHandlers = {
      peerconnection: function (e) {
        e.peerconnection.addEventListener("addstream", function (e) {
          remoteAudio.srcObject = e.stream;
          remoteAudio.play();
        });
      },
      accepted: function (e) {},
      confirmed: function (e) {},
    };
    let telephone = contact.toString().replace(/^233+/, "");
    // let telephone = contact.toString().replace(/^0+/, "");
    if (telephone.toString().length < 10) {
      telephone = "0" + telephone;
    }
    sipRegister();
    if (oUserAgent) {
      oUserAgent.call(`sip:${telephone}@${sipServer.domain}`, callOptions);
    }
  }
};

function transferCall() {
  if (oSession && pageDefaultValues.callTransaferInputField) {
    let eventHandlers = {
      requestSucceeded: function (e) {
        setCallSessionStatus(
          oSession,
          "transfer_request_succeeded",
          e.response
        );
      },
      requestFailed: function (e) {
        setCallSessionStatus(oSession, "transfer_request_failed", e.response);
      },
    };
    Object.assign(pageDefaultValues, { tranferring: true });
    oSession.refer(pageDefaultValues.callTransaferInputField, {
      eventHandlers,
      extraHeaders: [
        `Contact: <sip:${pageDefaultValues.callTransaferInputField}@${sipServer.domain}>`,
      ],
    });
  }
}

var answerCall = function () {
  Object.assign(pageDefaultValues, { answering: true });
  oSession.answer(callOptions);
};

var terminateCall = function () {
  if (oSession && !oSession.isEnded()) {
    oSession.terminate({ reason_phrase: "terminated" });
  }
  oSession = null;
};

var muteCall = function () {
  if (oSession)
    if (pageDefaultValues.isCallMuted) {
      oSession.unmute();
    } else {
      oSession.mute({ audio: true });
    }
};

var holdCall = function () {
  if (oSession)
    if (pageDefaultValues.isCallOnHold) {
      oSession.unhold();
    } else {
      oSession.hold();
    }
};

function setCallSessionStatus(session, status, request) {
  var callerExtension = request?.from?._uri?._user;
  var transaferExtension = request?.to?._uri?._user;
  oSession = session;

  switch (status) {
    case "connecting": {
      session.on("connecting", function () {
        Object.assign(pageDefaultValues, {
          showRegDialog: true,
          showCallDialog: false,
          showCallTimer: true,
          answering: false,
          txtCallStatus:
            "Call accepted for " + validatePhoneNumber(callerExtension),
          callTimer: "Connecting...",
        });
      });
      break;
    }
    case "peerconnection": {
      togglePlayRingTone({ play: false, type: "outgoing" });
      break;
    }
    case "accepted": {
      togglePlayRingTone({ play: false });
      Object.assign(pageDefaultValues, {
        showRegDialog: false,
        showCallDialog: false,
        showCallTimer: true,
        answering: false,
        txtCallStatus: "Talking to " + validatePhoneNumber(callerExtension),
        currentIncomingCaller: validatePhoneNumber(callerExtension),
      });
      startAnsweredCall();
      store.commit("app/setOnActiveCall", true);
      store.commit("app/setOnTicketSubmitted", false);
      store.commit("app/setSipSessionTrackerCode", utils.uuid());
      app.navigateTo(
        `/complaints/add/${validatePhoneNumber(callerExtension)}/incoming`
      );
      // app.navigateTo(`/complaints/add/${validatePhoneNumber(callerExtension)}`);
      break;
    }
    case "terminated": {
      clearInterval(callTimerinterval);
      Object.assign(pageDefaultValues, {
        txtTransferStatus: "",
        callTimer: "00:00",
        showRegDialog: true,
        showCallDialog: false,
        showCallTimer: false,
        answering: false,
        saving: false,
        calling: false,
        currentIncomingCaller: "",
      });
      togglePlayRingTone({ play: false });
      store.commit("app/setOnActiveCall", false);
      store.commit("app/setSipSessionTrackerCode", utils.uuid());
      terminateCall();
      break;
    }
    case "incoming": {
      togglePlayRingTone({ play: true });
      Object.assign(pageDefaultValues, {
        callTimer: "00:00",
        showRegDialog: false,
        showCallDialog: true,
        showCallTimer: false,
        answering: false,
        calling: false,
        txtCallStatus: "Call from " + validatePhoneNumber(callerExtension),
      });
      break;
    }
    case "outgoing": {
      store.dispatch("app/closeCallBackDialog");
      Object.assign(pageDefaultValues, {
        txtCallStatus: "Calling " + transaferExtension,
        showRegDialog: false,
        showCallTimer: true,
        answering: false,
        saving: false,
        calling: false,
      });
      startAnsweredCall();
      break;
    }
    case "hold": {
      Object.assign(pageDefaultValues, { isCallOnHold: true });
      app.flashMsg("Call Center", "Call is on hold", "info");
      break;
    }
    case "unhold": {
      Object.assign(pageDefaultValues, { isCallOnHold: false });
      app.flashMsg("Call Center", "Call is resumed", "success");
      break;
    }
    case "muted": {
      Object.assign(pageDefaultValues, { isCallMuted: true });
      app.flashMsg("Call Center", "Local audio is muted", "info");
      break;
    }
    case "unmuted": {
      Object.assign(pageDefaultValues, { isCallMuted: false });
      app.flashMsg("Call Center", "Local audio is unmuted", "success");
      break;
    }
    case "transfer_request_succeeded": {
      Object.assign(pageDefaultValues, {
        txtTransferStatus: `Transferring call to ${pageDefaultValues.callTransaferInputField} .. `,
        showCallTimer: false,
        saving: false,
      });
      setTimeout(function () {
        app.flashMsg("Call Center", "Transfer request successful", "success");
        Object.assign(pageDefaultValues, {
          txtTransferStatus: "",
          callTransaferInputField: "",
        });
        terminateCall();
      }, 2000);
      break;
    }
    case "transfer_request_failed": {
      Object.assign(pageDefaultValues, {
        txtTransferStatus: "",
      });
      app.flashMsg("Call Center", "Transfer request failed", "info");
      terminateCall();
      break;
    }
    default:
      break;
  }
}

function validatePhoneNumber(callerExtension) {
  let telephone = callerExtension.toString().replace(/^0+/, "");
  if (telephone.toString().length < 10) {
    telephone = "233" + telephone;
  }
  return telephone;
}

function togglePlayRingTone({ play = true, type = "incoming" }) {
  try {
    let tone = type == "incoming" ? ringtone : ringbacktone;
    if (!ringtoneAudio) ringtoneAudio = new Audio(tone);
    if (play) {
      if (typeof ringtoneAudio.loop == "boolean") {
        ringtoneAudio.loop = true;
        ringtoneAudio.autoplay = true;
      }
      ringtoneAudio.currentTime = 0;
      var resp = ringtoneAudio.play();
      if (resp !== undefined) {
        resp
          .then((_) => {
            // autoplay starts!
          })
          .catch((error) => {});
      }
    } else {
      ringtoneAudio.pause();
    }
  } catch (e) {}
}

async function fetchCallPlaybackAudio(src, dst, type = "incoming") {
  if (auth.isLoggedIn)
    try {
      let complaint =
        type == "outgoing"
          ? `&complaint_id=${callBackDialog.value.complaintId}`
          : "";
      const response = await ApiService.get(
        `components_data/fetch_playback_audio?lookup_src=${src}&lookup_dst=${dst}${complaint}`
      );
      const apiData = response.data;
    } catch (err) {}
}
</script>

<style lang="scss">
@import "./App.scss";
.layout-topbar .layout-topbar-button:hover {
  background-color: #0c447a;
}
.callTimerBtn {
  // width: 2.3em !important;
  height: 2.3em !important;
}
.layout-topbar .layout-topbar-logo:focus {
  box-shadow: none !important;
}
.blinkingBtn {
  background-color: #1c87c9;
}
@keyframes glowing {
  0% {
    background-color: #2ba805;
    box-shadow: 0 0 5px #1a5708;
  }
  50% {
    background-color: #42b420;
    box-shadow: 0 0 20px #1a5708;
  }
  100% {
    background-color: #2c6c18;
    box-shadow: 0 0 5px #2ba805;
  }
}
.blinkingBtn {
  animation: glowing 1300ms infinite;
}
</style>
